/**
*	@author Camilo
*	@since  26/10/2017
**/
export class NegocioModel{

	public nestadot:string;

	constructor(
		public id:ParamNegociosId, 
		public vnombrenegocio:string, 
		public cnit:string, 
		public nidcheck:number,
		public dfechacreacion:Date,
		public vdireccion:string, 
		public defCiudades:DefCiudades, 
		public ntelefono:string, 
		public vcorreo:string, 
		public defContribuyentes:DefContribuyentes,
		public vregimen:string,
		public ccodcontab:string,
		public nestado:number,
		public bloquear:number,
		public ntipo:string,
		public nvalor:number,
		public ccodemi:String,
		public ntiponegocio:any,
		public nactaterminacion:any,
		public vjefeadmon:string
		) {}
	

}

export class ParamNegociosId{
	constructor(public cnumcont:string, public ntipoempresa:number){}
}
export class DefCiudades{
	constructor(public id:DefCiudadesId){}
}
export class DefCiudadesId{
	constructor(public ccodigociudad:number, public ccodigodepto:string,public ccodigopais:string){

	}
}
export class DefContribuyentes{
	constructor(public nidcontribuyente:string){}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Negocio/Negocio.model.ts